const extracurricular = [
    {
      title: "Electrical Lead",
      organization: "Tennessee Lunabotics - University of Tennessee",
      startDate: "July 2021",
      endDate: "August 2023",
      description: `
        As the Electrical Lead for Tennessee Lunabotics, I led the design and development of the electrical systems for our mining robot for the NASA Lunabotics Competition. This involved overseeing the wiring, power distribution, and integration of sensors and motors to ensure reliable and efficient operation of the robot. I worked closely with a team of interdisciplinary engineers to meet project deadlines and deliverables while maintaining a strong focus on safety and performance.
      `
    },
    {
      title: "Participant",
      organization: "Deutsche Bank Early Career Hackathon",
      startDate: "June 2023",
      endDate: "June 2023",
      description: `
        Selected as one of 25 students nationwide to participate in Deutsche Bank's inaugural Early Career Hackathon held in Cary, NC. Engaged in a 7-hour sprint to develop an innovative project aimed at rethinking credit score calculations. Collaborated with a team to design and prototype an alternative credit scoring model tailored for students, incorporating academic and socioeconomic factors to provide a more comprehensive evaluation of creditworthiness. This experience enhanced my skills in rapid prototyping, teamwork, and applying technological solutions to financial challenges.
      `
    },    
    {
      title: "Recruitment Chair",
      organization: "Women's Rugby - University of Tennessee",
      startDate: "January 2023",
      endDate: "August 2024",
      description: `
        As Recruitment Chair for the Women's Rugby team, I was responsible for managing recruitment efforts, organizing informational meetings, and coordinating tryouts. My efforts helped to increase the team's membership and diversity. I also developed marketing strategies to enhance the team’s visibility on campus and ensure we attracted talented players.
      `
    },
    {
      title: "Vice President",
      organization: "German Club - University of Tennessee",
      startDate: "May 2022",
      endDate: "May 2023",
      description: `
        As Vice President of the German Club, I played a key role in organizing cultural events, language practice sessions, and club meetings. I also collaborated with other student organizations to host joint events that promoted German culture and language learning on campus. I assisted in managing the club's activities and helped to foster a welcoming environment for all students interested in the German language and culture.
      `
    },

    {
      title: "Student Teacher - German Language",
      organization: "E.C. Glass High School",
      startDate: "August 2019",
      endDate: "May 2020",
      description: `
      As a student teacher for German Language levels 1 through 3, I collaborated with faculty to support classroom instruction and enhance student engagement. I created quizzes, interactive lecture games, and comprehensive review materials tailored to various proficiency levels. My role also included and providing one-on-one support to students, helping to foster a deeper understanding and appreciation of the German language.
      `
    },

    {
      title: "Instagram Takeover",
      organization: "University of Tennessee's Global Affairs Department and Official University of Tennessee Account",
      startDate: "April 2023",
      endDate: "April 2023",
      description: `
        As part of a special initiative, I conducted an Instagram takeover for the UTK Global Affairs Department and the official UTK Instagram account. During this event, I shared my experiences and insights related to study abroad, campus life, and my involvement in the university’s global community. This opportunity allowed me to engage with a broad audience and showcase the diverse opportunities available to students at UTK.
      `
    },
    {
      title: "Participant",
      organization: "Virginia Governor's German Language Academy",
      startDate: "June 2019",
      endDate: "July 2019",
      description: `
        Selected to attend the Virginia Governor's German Language Academy, a prestigious three-week full-immersion program hosted at Washington and Lee University. Engaged exclusively in German for all academic and social interactions, enhancing language proficiency and cultural understanding. Participated in intensive language courses, cultural workshops, and collaborative projects with peers and instructors from diverse backgrounds, culminating in a comprehensive presentation in German and a basic understanding of Russian Language.
      `
    },
    {
      title: "Exchange Student",
      organization: "German American Partnership Program (GAPP)",
      startDate: "June 2018",
      endDate: "October 2018",
      description: `
        Participated in the German American Partnership Program, a bilateral exchange initiative fostering cultural and educational ties between the U.S. and Germany. In June 2018, I lived with a host family in Berlin for three weeks, attending a local German high school and immersing myself in German language and culture. In October 2018, I hosted my German exchange partner for three weeks, providing her with an opportunity to experience American culture and education firsthand. This exchange enhanced my cross-cultural communication skills and deepened my understanding of German society.
      `
    },
    {
      title: "President",
      organization: "Virginia Organization of German Students (VOGS)",
      startDate: "July 2019",
      endDate: "August 2020",
      description: `
        As President of VOGS -- a state-wide organization established in 1978 to promote interest in the German language and culture throughout Virginia schools -- I led initiatives to foster engagement among German students across the state. I coordinated events, facilitated communication between member schools, and worked to increase participation in German language activities. My leadership contributed to enhancing the organization's visibility and strengthening its network within the educational community.
      `
    }
    
    
    
  
  ];
  
  export default extracurricular;
  